import styled from 'styled-components';
import BaseStopStationIcon from '#/shared/components/BaseStopStationIcon';
import BaseFeedbackIcon from '#/shared/components/GeneratedIcons/generic/Feedback';
import {
  TripButton as BaseTripButton,
  InverseClearLink,
} from '#/shared/components/Styled';

import { XXSPHONE_BREAK } from '#/shared/constants';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (min-width: ${XXSPHONE_BREAK}) {
    flex-direction: row;
  }
`;

export const TripButtonsWrapper = styled.div`
  display: flex;
  margin: 0 0 5px 0;
  justify-content: space-between;
  @media (min-width: ${XXSPHONE_BREAK}) {
    margin: 0;
  }
  & > button {
    margin: 0 5px 0 0;
  }
  & > button:last-child {
    margin: 0;
  }
`;

export const TripButton = styled(BaseTripButton)`
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
`;

export const ShareFeedbackLink = styled(InverseClearLink)`
  display: flex;
  flex: inline;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  padding: 6px 5px;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.secondaryBackgroundColor};
  @media (min-width: ${XXSPHONE_BREAK}) {
    margin-left: 5px;
  }
`;

export const StopStationIconSolid = styled(BaseStopStationIcon).attrs(
  props => ({
    width: '80%',
    height: '80%',
    fill: props.theme.secondaryBackgroundColor,
    isSolid: true,
  })
)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const TitleContainer = styled.div`
  align-items: center;
  line-height: unset;
  display: flex;
  justify-content: space-between;
`;

export const ShareFeedbackLinkText = styled.div`
  flex: 0 0 auto;
  text-align: left;
`;

export const ShareFeedbackLinkIcon = styled.div`
  flex: 0 0 auto;
  padding: 0 5px 0 0;
  border-radius: 5px;
  display: flex;
`;

export const ShareFeedbackIcon = styled(BaseFeedbackIcon).attrs(props => ({
  width: 15,
  height: 15,
  fill: props.theme.inverseFontColor1,
}))`
  flex: 0 0 20px;
`;
